export default "__VITE_ASSET__DIfYtZ_p__"